const countdown = {

    init: () => {


        let seconds = 0;
        const x = setInterval(function () {
            countdown.calc(x, seconds);
            seconds += 1;
        }, 1000);

        countdown.calc(x, seconds);
    },

    calc: (x, sec) => {

        let todate = new Date("Dec 28, 2024 12:00:00").getTime();

        let now = new Date(dt).getTime();
        let span = todate - now - (sec * 1000);

        let days = Math.floor(span / (1000 * 60 * 60 * 24));
        let hours = Math.floor((span % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((span % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((span % (1000 * 60)) / 1000);

        if (span < 0) {
            clearInterval(x);
            days = 0;
            hours = 0;
            minutes = 0;
            seconds = 0;
        }

        let elmdays = helper.element(".js-day");
        let elmhours = helper.element(".js-hour");
        let elmminutes = helper.element(".js-minute");
        let elmseconds = helper.element(".js-second");

        if (elmdays && elmhours && elmminutes && elmseconds) {
            elmdays.innerText = days.toString().padStart(2, "0");
            elmhours.innerText = hours.toString().padStart(2, "0");
            elmminutes.innerText = minutes.toString().padStart(2, "0");
            elmseconds.innerText = seconds.toString().padStart(2, "0");
        }

    }
};